module.exports = __webpack_public_path__ + "media/customizations/regencyateverrange/logo-new-155d4c84d3f0864755f434ba4ae37175.png";